import { Route, Routes } from "react-router"
import DefaultLayout from "../layouts/DefaultLayout";
import Home from "../pages/Home/Home";
import NotFound from "../pages/NotFound/NotFound";
import CategoryListPage from "../pages/CategoryListPage/CategoryListPage";
import ProductPage from "../pages/ProductPage/ProductPage";
import SearchPage from "../pages/SearchPage/SearchPage";
import BasketPage from "../pages/BasketPage/BasketPage";
import AboutPage from "../pages/AboutPage/AboutPage";
import AboutCompany from "../pages/AboutPage/components/AboutCompany";
import TermsOfUse from "../pages/AboutPage/components/TermsOfUse";
import PrivacyPolicy from "../pages/AboutPage/components/PrivacyPolicy";
import AccountPage from "../pages/AccountPage/AccountPage";
import MyOrders from "../pages/AccountPage/components/MyOrders";
import Favorites from "../pages/AccountPage/components/Favorites";
import AccountSettings from "../pages/AccountPage/components/AccountSettings";
import OrderDetails from "../pages/AccountPage/components/OrderDetails";

const ScaenaRouter: React.FC = () => {
   return (
    <Routes>
        <Route path="/" element={<DefaultLayout></DefaultLayout>}>
            <Route index element={<Home></Home>}></Route>
            <Route path="category/:refKey" element={<CategoryListPage></CategoryListPage>}></Route>
            <Route path="product/:refKey" element={<ProductPage></ProductPage>}></Route>
            <Route path="search" element={<SearchPage></SearchPage>}></Route>
            <Route path="cart" element={<BasketPage></BasketPage>}></Route>
            <Route path="about" element={<AboutPage></AboutPage>}>
                <Route index element={<AboutCompany></AboutCompany>}></Route>
                <Route path="terms" element={<TermsOfUse></TermsOfUse>}></Route>
                <Route path="privacy" element={<PrivacyPolicy></PrivacyPolicy>}></Route>
            </Route>
            <Route path="profile" element={<AccountPage></AccountPage>}>
              <Route index element={<MyOrders></MyOrders>}></Route>
                <Route path="favorites" element={<Favorites></Favorites>}></Route>
                <Route path="orders/:id" element={<OrderDetails></OrderDetails>}></Route>
                <Route path="settings" element={<AccountSettings></AccountSettings>}></Route>
            </Route>
            <Route path="*" element={<NotFound></NotFound>}></Route>
        </Route>
    </Routes>
   )
}

export default ScaenaRouter;